module.exports = __webpack_public_path__ + "img/addon_2.f2bba2f9.png";